// @flow

// Libs
import composeOperator from 'fc-operations'

// Constants
import {
  MODEL,
  BRANCH,
} from 'hfty-model-reopen-job'

// Types
import type { ReopenJobOperator } from '../types'

// Exports
export const operator: ReopenJobOperator = composeOperator({
  model: MODEL,
  branch: BRANCH,
})

export default operator
